var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfirmation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 420.736,
    height: 372.591,
    viewBox: "0 0 420.736 372.591",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_17060",
    "data-name": "Group 17060",
    transform: "translate(1573.842 2837.3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2753",
    "data-name": "Path 2753",
    d: "M763.132,3629.436c12.263,1.194,37.914-2.76,42.412-28.1s16.521-32.358,21.973-32.7",
    transform: "translate(-1982.213 -6388.978)",
    fill: "none",
    stroke: "#f3603f",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_230",
    "data-name": "Ellipse 230",
    cx: 122.61,
    cy: 122.61,
    r: 122.61,
    transform: "translate(-1450.592 -2778.761)",
    fill: "#53b175"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9983",
    "data-name": "Group 9983",
    transform: "translate(-1433.638 -2761.807)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_231",
    "data-name": "Ellipse 231",
    cx: 105.655,
    cy: 105.655,
    r: 105.655,
    transform: "translate(0 0)",
    fill: "none",
    stroke: "rgba(255,255,255,0.7)",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2754",
    "data-name": "Path 2754",
    d: "M766.729,3661.689a12.292,12.292,0,0,1-3.692,8.853l-55.379,53.648a13.8,13.8,0,0,1-9.291,3.691,13.279,13.279,0,0,1-9.17-3.691l-27.75-26.824a12.291,12.291,0,0,1-3.692-8.853,12.634,12.634,0,0,1,3.811-8.869,14.114,14.114,0,0,1,9.17-3.69,13.4,13.4,0,0,1,9.171,3.582l18.459,17.831,46.21-44.655a13.4,13.4,0,0,1,9.17-3.581,13.752,13.752,0,0,1,9.17,3.8A12.192,12.192,0,0,1,766.729,3661.689Z",
    transform: "translate(-2040.225 -6344.665)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2755",
    "data-name": "Path 2755",
    d: "M752.1,3753.6c11.446,3.318,33.575,15.877,30.522,39.677",
    transform: "translate(-1988.284 -6287.152)",
    fill: "none",
    stroke: "#f7b23b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2756",
    "data-name": "Path 2756",
    d: "M535.578,3749.566c17.564,6.6,55.432,11.35,66.381-22.591m0,0c1.6-9.35,0-27.847-19.162-27.025C579.148,3708.958,577.87,3726.975,601.959,3726.975Zm0,0c7.984,1.488,26.553.062,36.954-17.443",
    transform: "translate(-2107.488 -6316.702)",
    fill: "none",
    stroke: "#6e89fa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_232",
    "data-name": "Ellipse 232",
    cx: 11.752,
    cy: 11.752,
    r: 11.752,
    transform: "translate(-1304.924 -2488.214)",
    fill: "#637bfe"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_233",
    "data-name": "Ellipse 233",
    cx: 10.977,
    cy: 10.977,
    r: 10.977,
    transform: "translate(-1193.047 -2673.532)",
    fill: "none",
    stroke: "#c05efd",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_234",
    "data-name": "Ellipse 234",
    cx: 12.87,
    cy: 12.87,
    r: 12.87,
    transform: "translate(-1381.496 -2837.3)",
    fill: "#53b175"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_235",
    "data-name": "Ellipse 235",
    cx: 6.797,
    cy: 6.797,
    r: 6.797,
    transform: "translate(-1338.884 -2809.504)",
    fill: "#f3603f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_236",
    "data-name": "Ellipse 236",
    cx: 11.136,
    cy: 11.136,
    r: 11.136,
    transform: "translate(-1493.025 -2714.036)",
    fill: "none",
    stroke: "#f7b23b",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_237",
    "data-name": "Ellipse 237",
    cx: 12.322,
    cy: 12.322,
    r: 12.322,
    transform: "translate(-1466.852 -2527.407)",
    fill: "none",
    stroke: "#53b175",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_238",
    "data-name": "Ellipse 238",
    cx: 6.257,
    cy: 6.257,
    r: 6.257,
    transform: "translate(-1323.456 -2483.678) rotate(180)",
    fill: "#53b175"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmation);
export default __webpack_public_path__ + "static/media/confirmation.22965fe30887114c2e20c92815182441.svg";
export { ForwardRef as ReactComponent };